module.exports = __webpack_public_path__ + "6c87118aca6f1e793a129521b523a107.svg";